module.exports = require("reselect");


//////////////////
// WEBPACK FOOTER
// external "reselect"
// module id = 37
// module chunks = 0